module.exports = __webpack_public_path__ + "img/IMG_4702.2ff17a41.jpg";